<template>
  <div>
    <el-card style="margin-bottom: 12px;">
      <div style="display: flex; align-items: center; gap: 16px;">
        <span style="font-size: 14px; color: #606266;">
          目前上線人數：
          <strong style="font-size: 18px; color: #409EFF;">{{ count }}</strong>
        </span>
        <el-button type="primary" :loading="isLoading" @click="fetchSessions">
          重新整理
        </el-button>
      </div>
    </el-card>

    <el-table
      :data="sessions"
      v-loading="isLoading"
      border
      size="mini"
      stripe
      style="width: 100%;"
    >
      <el-table-column label="Email" prop="email" min-width="200">
        <template #default="{ row }">
          {{ row.user && row.user.email || row.email || '-' }}
        </template>
      </el-table-column>
      <el-table-column label="姓名" min-width="120">
        <template #default="{ row }">
          {{ row.user && row.user.name || '-' }}
        </template>
      </el-table-column>
      <el-table-column label="權限" min-width="90">
        <template #default="{ row }">
          {{ row.user && row.user.roles || '-' }}
        </template>
      </el-table-column>
      <el-table-column label="IP 位址" prop="ipAddress" min-width="140">
        <template #default="{ row }">
          {{ row.ipAddress || '-' }}
        </template>
      </el-table-column>
      <el-table-column label="登入時間" min-width="150">
        <template #default="{ row }">
          {{ formatTime(row.issuedAt) }}
        </template>
      </el-table-column>
      <el-table-column label="到期時間" min-width="150">
        <template #default="{ row }">
          {{ formatTime(row.expiresAt) }}
        </template>
      </el-table-column>
      <el-table-column label="User Agent" min-width="240">
        <template #default="{ row }">
          <span style="font-size: 11px; color: #909399; word-break: break-all;">
            {{ row.userAgent || '-' }}
          </span>
        </template>
      </el-table-column>
      <el-table-column label="操作" width="200" fixed="right">
        <template #default="{ row }">
          <el-button
            type="danger"
            size="mini"
            @click="kickSession(row)"
          >
            踢出此 Session
          </el-button>
          <el-button
            type="warning"
            size="mini"
            style="margin-top: 4px;"
            @click="kickUserAll(row)"
          >
            踢出全部
          </el-button>
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>

<script>
import moment from 'moment';

export default {
  name: 'SessionList',
  data() {
    return {
      isLoading: false,
      count: 0,
      sessions: [],
    };
  },
  mounted() {
    this.fetchSessions();
  },
  methods: {
    formatTime(value) {
      if (!value) return '-';
      return moment(value).format('YYYY-MM-DD HH:mm');
    },
    fetchSessions() {
      this.isLoading = true;
      return this.$axios({
        category: 'admin',
        method: 'get',
        apiName: 'sessions',
      })
        .then(res => {
          this.count = res.data.count;
          this.sessions = res.data.sessions;
        })
        .catch(this.$notifyError)
        .finally(() => {
          this.isLoading = false;
        });
    },
    kickSession(row) {
      const email = (row.user && row.user.email) || row.email || row._id;
      this.$confirm(`確定要踢出 ${email} 的此 Session？`, '確認踢出', {
        confirmButtonText: '踢出',
        cancelButtonText: '取消',
        type: 'warning',
      }).then(() => {
        return this.$axios({
          category: 'admin',
          method: 'delete',
          apiName: `sessions/${row._id}`,
        });
      }).then(() => {
        this.$notifySuccess('已踢出 Session');
        this.fetchSessions();
      }).catch(err => {
        if (err !== 'cancel') this.$notifyError(err);
      });
    },
    kickUserAll(row) {
      const userId = row.user && row.user._id;
      const email = (row.user && row.user.email) || row.email || '-';
      if (!userId) {
        this.$notifyError('找不到用戶 ID');
        return;
      }
      this.$confirm(`確定要踢出 ${email} 的所有 Session？`, '確認踢出全部', {
        confirmButtonText: '全部踢出',
        cancelButtonText: '取消',
        type: 'warning',
      }).then(() => {
        return this.$axios({
          category: 'admin',
          method: 'delete',
          apiName: `sessions/user/${userId}`,
        });
      }).then(() => {
        this.$notifySuccess('已踢出該用戶所有 Session');
        this.fetchSessions();
      }).catch(err => {
        if (err !== 'cancel') this.$notifyError(err);
      });
    },
  },
};
</script>
